import { CTATheme } from '../../utils/constants/CTATheme'

export { CTAButton } from './element'

export interface ICTAButtonData {
  text: string
  onClick: (...args: any[]) => any
}

export interface IProps extends ICTAButtonData {
  variant?: CTATheme
  small?: boolean
  dataAttribute?: string
  eventContext?: string
  loading?: boolean
  type?: 'button' | 'submit' | 'reset'
  icon?: 'Arrow' | 'Play'
  wide?: boolean
  disabled?: boolean
}
